import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Observer from "react-intersection-observer";
import classNames from "classnames";
import Button from './Button.js';
import logo from '../images/logo.svg';
import { GAfireEvent } from './Tracking';
import Autocomplete from "./Autocomplete";
import ToggleableIcon from "./ToggleableIcon";
import Filter from "./Filter";
import NavMobile from './NavMobile.js';
import SecondaryNav from './SecondaryNav/index.js';
import { isEs } from "../libs/lang";
import 'wicg-inert';

import {fireTag} from '../libs/analytics.js';

const logoMobile = logo;

const SkipToH1 = ({activePage}) => {
	return (
		<a
			id="skip-to-main"
			href={`#${activePage}-main-h1`}
			onClick={(e) => {
				e.preventDefault();
				window.scrollTo({
					top: document.getElementById(`${activePage}-main-h1`).getBoundingClientRect().top - 75,
					left: 0,
				});
				document.getElementById(`${activePage}-main-h1`).focus()
			}}
		>{isEs() ? `Pase al contenido principal` : `Skip to main content`}</a>
	)
}

const Nav = ({
				 handleEvent, isNotHomePage,
				 isMobile,
				 forwardedRef, activePage, results, checkForCityOrZip, location, stateShowFilter, mapLoading, chooseDropdownType, toggleInert, shouldBeInert
			 }) => {
	const getZoom = () => window.outerWidth/window.innerWidth;

	const isMobileLocal = isEs() ? window.innerWidth <= 1079 : window.innerWidth <= 767;

	useEffect(() => {

		const navElement = document.querySelector('nav.sticky-nav');
		const secondaryStickyNav = document.querySelector('nav.secondaryNav.stickyVersion') || false;
		const secondaryStickyNavLinks = document.querySelectorAll('nav.secondaryNav.stickyVersion a') || false;
		const usesubNavShade = document.querySelector('.secondaryNav.scrollVersion') || false;


		console.log({isMobile, isMobileLocal});

		if (window.outerWidth / window.innerWidth >= 2) {
			document.querySelector('nav').style.position = "relative";
		}
		else {
			if (window.location.pathname.includes('map')) {
				document.querySelector('nav').style.position = "relative";
			}
			else {
				document.querySelector('nav').style.position = "fixed";
			}
		}

		window.addEventListener('scroll', () => {

			if (secondaryStickyNav) {
				if (!isMobileLocal && document.documentElement.scrollTop < 20) {
					//secondaryStickyNav.classList.remove('show');
				}
			}

		});

		// if (secondaryStickyNav && (!isMobileLocal || !isMobile)) {
		if (secondaryStickyNav && !isMobileLocal) {
			navElement.addEventListener('mouseover', () => {
				if (usesubNavShade && usesubNavShade.getBoundingClientRect().top <= 20) {
					// secondaryStickyNav.classList.add('show');
					secondaryStickyNavLinks.forEach(link => {
						link.tabIndex = '0';
					})
				}
			});

			navElement.addEventListener('mouseout', () => {
				// secondaryStickyNav.classList.remove('show');
				secondaryStickyNavLinks.forEach(link => {
					//link.tabIndex = '-1';
				})
			});
		}
	});

	return (
		<nav ref={forwardedRef} className="sticky-nav" aria-label="Site Navigation">
			{isMobileLocal && getZoom() >= 0.9 ? (
			// {isMobileLocal ? (
				<>
					<SkipToH1 activePage={activePage}/>
					{isNotHomePage &&
						(<Button handleClick={() => {
							handleEvent({action: 'back'});
						}} buttonStyles="back"/>)
					}
					<a
						id="wf-logo"
						href={isNotHomePage ? `${process.env.PUBLIC_URL}/` : 'https://www.wellsfargo.com/'}
						target={isNotHomePage ? '' : '_blank'}
						onClick={() => {
							fireTag("G1");
							handleEvent({
								action: 'clear-search',
								type: '',
								name: '',
							});
							//GAfireEvent('G1');
						}} rel="noreferrer"
					>
						<img src={logoMobile} alt="Wells Fargo logo"/>{' '}
					</a>
					{isNotHomePage ? (
						<ul className="nav-links" role="menu">
							<li role="menuitem">
								<Link
									to="/"
									onClick={() => {
										fireTag('G5');
										handleEvent({
											action: 'clear-search',
											type: '',
											name: '',
											origin: 'results',
										});
									}}
								>
									Home
								</Link>
							</li>
							<li role="menuitem">
								<Link
									to="/map/"
									onClick={()=>fireTag('G6')}
								>
									Map
								</Link>
							</li>
						</ul>
					) : (
						<NavMobile
							activePage={activePage}
							toggleInert={toggleInert}
						/>
					)}
				</>
			) : (
				<>
					<SkipToH1 activePage={activePage}/>
					<a
						className={isNotHomePage && activePage === "organization-detail" ? "org-home-link" : ""}
						href={isNotHomePage ? `${process.env.PUBLIC_URL}/` : 'https://www.wellsfargo.com/'}
						target={isNotHomePage ? '' : '_blank'}
						onClick={() => {
							//GAfireEvent('G1')
							fireTag('G1');
						}} rel="noreferrer">
						<img lang="en" src={logo} alt="Wells Fargo logo"/>
					</a>
					{

						!isNotHomePage && (
							isEs() ?
								<a
									lang="en"
									className="language-toggle"
									href={window.location.href.replace('/es', '')}>
									English
								</a> : null
						)
					}
					{
						(activePage === 'home' || activePage === 'housing') &&
						(
							!isEs() ?
								<a lang='es' className="language-toggle"
									//# rename
									// href={window.location.href.replace('/impact-wi-1629/','/es/iimpact-wi-1629/')}>
									href={window.location.href.replace('/impact/', '/es/impact/')}>
									Español
								</a> : null
						)

					}

					{isNotHomePage && activePage === "organization-detail" &&
						(<section className="organizations results group">
							<section className="organizations__search-controls">
								<ul className="nav-links" role="menu">
									<li role="menuitem" className="home">
										<a
											href={`${process.env.PUBLIC_URL}/`}
											onClick={() => {
												fireTag('G1');
												handleEvent({
													action: 'clear-search',
													type: '',
													name: '',
													origin: 'organization'
												});
											}}
										>
											Home
										</a>
									</li>
									<li role="menuitem" className="search">
										<Link to={

											location.search.indexOf('target=district') > -1
												? (`/district/`)
												: (`/map/`)
										}>Map</Link>
									</li>
								</ul>
								<form
									role="search"
									autoComplete="off"
									onSubmit={event => {
										event.preventDefault();
									}}
								>
									<Autocomplete
										orgResults={results.all}
										checkForCityOrZip={checkForCityOrZip}
										handleTextSearch={
											inputObj => {
												handleEvent({
													action: 'input',
													name: 'results',
													value: inputObj,
													origin: 'organization'
												});
												handleEvent({
													action: 'search',
													type: 'input',
													name: 'results',
													origin: 'organization'
												});
											}}
										route="organization"
									/>
								</form>
								<p className="sep-text">or</p>
								<section className="organizations__filter-controls nav">
									{/* FILTER COLUMN and DROPDOWN */}
									<Observer tag="div">
										{/* FILTER DROPDOWN */}
										<div
											role="menu"
											tabIndex={0}
											className="filter-panel-dropdown"
											onClick={() =>
												handleEvent({
													action: 'toggle',
													type: 'Filter',
													name: 'results',
													origin: 'organization'
												})
											}
											onKeyDown={event => {
												if (event.key === 'Enter') {
													handleEvent({
														action: 'toggle',
														type: 'Filter',
														name: 'results',
														origin: 'organization'
													})
												}
											}}
										>

											<button type="button" className="toggle type full" aria-expanded={stateShowFilter} disabled={mapLoading}>
												{!mapLoading ? `Search by Category` : `Loading...`}
												<ToggleableIcon isUp={stateShowFilter} className="indicator"/>
											</button>
											<Filter
												{...{location}}
												handleFilterClick={
													// Congressional District Category filter selection
													community => chooseDropdownType(community, 'organization')
												}
												styles={classNames('menu-dropdown', {open: stateShowFilter})}
												expanded={stateShowFilter}
												isDropdown
												isOrg
											/>
										</div>
									</Observer>
								</section>
							</section>
						</section>)
					}

					{(!isMobileLocal && (activePage === 'home' || activePage === 'housing' || activePage === 'sustainability' || activePage === 'articles')) && (
						<SecondaryNav
							shouldBeInert={shouldBeInert}
							activePage={activePage}
							stickyVersion
						/>
					)}
				</>
			)}
		</nav>
	);

};


export default Nav;
